import { gql } from '@apollo/client'

export default gql(`
query($id: ID!) {
    getMatch(id: $id) {
      id
      customVenueName
      tags{
        key
        name
        type
        module
      }
      isLiveOnly
      isBroadcast
      notLive
      asset{
        id
        isArchived
        shortId
        externalId
        title
        isLive
        isFree
        type
        updatedAt
        publishStartDate
        publishEndDate
        status
        vodStatus{
          id
          status
          site
          updatedAt
          createdAt
          errorDesc
          startTime
          endTime
        }
          vodJobs{
                id
                status
                site
                name
                type
                jobType
                vwmJobId
                updatedAt
                createdAt
                createdBy
                progress
                errorDesc
                startTime
                endTime 
                jobStates{
                    status
                    errorCode
                    updatedAt
                }
                channel{
                    id
                }
                mediaId{
                    id
                    duration
                }  
                }
        program{
          id
          source
          isLiveTelecast
          channel{
              id
              name
              channelCode
              icon{
                  id
                  fileName
                  aspectRatio {
                      aspectRatio
                      ratio
                      title          
                      resolutions {
                      url
                      }
                  }
                  settings {
                      aspectRatio
                      outputFormat
                      fileName
                      x1
                      y1
                      x2
                      y2
                  }
              }
              activeConfigGroup{
                  id
                  name
                  streams{
                      url
                      fields{
                          name
                          value
                          isRequired
                          type
                      }
                      streamSchema{
                          id
                          levels{
                              id
                              name
                          }
                      }
                  }
              }
          }
          broadCastStartTime
          broadCastEndTime
        }
        defaultMedia {
          id
          url
          fileName
          aspectRatio {
            title
            aspectRatio
            resolutions {
              url
            }
          }
          settings {
            aspectRatio
            outputFormat
            fileName
            x1
            y1
            x2 
            y2
          }
        }
      }
      opId
      description
      kickOffTime
      matchDate
      finishTime
      externalId
      homeTeam{
        id
        opId
        code
        officialName  
        media {
            fileName
            createdAt
            url
            aspectRatio {
                aspectRatio
                ratio
                title          
                resolutions {
                  url
                }
            }
            settings {
                aspectRatio
                outputFormat
                fileName
                x1
                y1
                x2
                y2          
            }
        }
      }
      awayTeam{
        id
        opId
        code
        officialName  
        media {
            fileName
            createdAt
            aspectRatio {
                aspectRatio
                ratio
                title          
                resolutions {
                  url
                }
            }
            settings {
                aspectRatio
                outputFormat
                fileName
                x1
                y1
                x2
                y2          
            }
        }
      }
      competition{
        id
        opId
        title
      }
      stage{
        title
        id
      }
      tournamentCalendar{
        title
        id
      }
      venue{
        title
      }
      programs{
        id
        source
        isLiveTelecast
        channel{
            id
            name
            channelCode
            icon{
              id
              fileName
              aspectRatio {
                aspectRatio
                ratio
                title          
                resolutions {
                  url
                }
              }
              settings {
                aspectRatio
                outputFormat
                fileName
                x1
                y1
                x2
                y2
              }
            }
            activeConfigGroup{
              id
              name
              streams{
                url
                fields{
                  name
                  value
                  isRequired
                  type
                }
                streamSchema{
                  id
                  levels{
                    id
                    name
                  }
                }
              }
            }
        }
        broadCastStartTime
        broadCastEndTime
      }
      status
      customMeta {
        config {
          default
          id
          name
          project
          section
          type
          usageCount
        }
        name
        value
      }
    }
}`)
